import React, { useState } from "react";
import { UploadZone, ResetButton } from "./_shared";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function Base64Encoder() {
  const [file, setFile] = useState(null);
  const [b64, setB64] = useState("");
  const [copied, setCopied] = useState(false);

  const handleFile = (f) => {
    setFile(f);
    const reader = new FileReader();
    reader.onload = () => setB64(reader.result);
    reader.readAsDataURL(f);
  };

  const copy = async () => {
    await navigator.clipboard.writeText(b64);
    setCopied(true); toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 1500);
  };

  const reset = () => { setFile(null); setB64(""); };

  if (!file) return <UploadZone onFile={handleFile} />;
  return (
    <div className="space-y-6">
      <img src={b64} alt="preview" className="max-h-60 rounded-xl border border-slate-200 dark:border-white/10" />
      <textarea
        readOnly
        value={b64}
        rows={10}
        className="w-full rounded-xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-[#0b0c0e] p-4 font-mono text-xs text-slate-700 dark:text-slate-200"
        data-testid="base64-output"
      />
      <div className="flex items-center gap-3">
        <button onClick={copy} data-testid="copy-base64" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-colors">
          {copied ? <Check size={16} /> : <Copy size={16} />} {copied ? "Copied" : "Copy Base64"}
        </button>
        <ResetButton onClick={reset} />
      </div>
    </div>
  );
}
